import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import { Button } from 'grab-ui';
import _isEmpty from 'lodash/isEmpty';
import _every from 'lodash/every';
import { isFetchingQuotesSelector } from 'selectors/new-booking-selectors';
import { NewBookingDeliveryPropType } from 'common/prop-types';
import { deliveryPriceReady } from 'common/anytime-booking/delivery';
import NewBookingDuck from 'ducks/new-booking-duck';

const RefreshFailedQuotesButton = ({ deliveries, disabled }) => {
  const dispatch = useDispatch();
  const isFetchingQuotes = useSelector(isFetchingQuotesSelector);

  const isDisabled = useMemo(
    () =>
      disabled ||
      isFetchingQuotes ||
      _isEmpty(deliveries) ||
      _every(deliveries, deliveryPriceReady),
    [deliveries, disabled, isFetchingQuotes],
  );

  const failedQuoteDeliveryIDs = useMemo(
    () => {
      if (!deliveries) {
        return [];
      }
      return deliveries
        .filter(delivery => !deliveryPriceReady(delivery))
        .map(delivery => delivery.id);
    },
    [deliveries],
  );

  const onClickRefresh = useCallback(
    deliveryIDs => () => {
      if (_isEmpty(deliveryIDs)) return;
      dispatch(NewBookingDuck.creators.batchFetchDeliveryQuotes(deliveryIDs));
    },
    [dispatch],
  );

  return (
    <Button
      id={'bulkRefreshQuoteButton'}
      onClick={onClickRefresh(failedQuoteDeliveryIDs)}
      disabled={isDisabled}
      loading={isFetchingQuotes}
    >
      {isFetchingQuotes
        ? I18n.t('bulkUploadRevamp.fetchingQuotes')
        : I18n.t('bulkUploadRevamp.refreshFailedQuotes')}
    </Button>
  );
};

RefreshFailedQuotesButton.propTypes = {
  deliveries: PropTypes.arrayOf(NewBookingDeliveryPropType).isRequired,
  disabled: PropTypes.bool,
};

RefreshFailedQuotesButton.defaultProps = {
  disabled: false,
};

export default RefreshFailedQuotesButton;
